import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbModal, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-super-users',
  standalone: true,
  imports: [CommonModule, FormsModule, NgbTooltipModule, ReactiveFormsModule],
  templateUrl: './super-users.component.html',
  styleUrl: './super-users.component.css'
})
export class SuperUsersComponent implements OnInit {

  userForm: FormGroup;
  roles = ['Super Executive', 'Super Finance'];

  constructor(private modalService: NgbModal, private fb: FormBuilder) {

    this.userForm = this.fb.group({
      role: ['', Validators.required],
      fullName: ['', Validators.required],
      mobileNumber: ['', Validators.required],
      email: ['', Validators.required],
      mappedUrl: ['', Validators.required],
      userName: ['', Validators.required],
      password: ['', Validators.required]
    });

  }

  users = [
    {
      role: 'Super Executive',
      fullName: 'Abqaiq',
      mobileNumber: '0123456789',
      email: 'test@gmail.com',
      mappedUrl: 'https://www.tdcdbabqaiq.smartsortsupport.com'
    },
    {
      role: 'Super Finance',
      fullName: 'Hafar Al Batin',
      mobileNumber: '0123123123',
      email: 'test@gmail.com',
      mappedUrl: 'https://www.tdcdbabqaiq.smartsortsupport.com'
    }
  ];


  // --------------------------- OnInit --------------------------- //

  ngOnInit() {

  }

  // --------------------------- Create Users Modal --------------------------- //

  createUsers(modal: any) {
    this.modalService.open(modal, { centered: true, backdrop: 'static', size: 'md' });
  }

  // --------------------------- Submit Users API --------------------------- //

  submitUserForm() {
    if (this.userForm.valid) {
      console.log('Form Data:', this.userForm.value);
      alert('User Created Successfully!');
    } else {
      alert('Please fill all required fields.');
    }
  }

  editItem(data: any, modal: any) {
    this.modalService.open(modal, { centered: true, backdrop: 'static', size: 'md' });
  }

  // --------------------------- Export to excel --------------------------- //

  exportToExcel() {

  }

  // --------------------------- Print --------------------------- //

  printGrid() {

  }

  // --------------------------- Clear Filter --------------------------- //

  clearGrid() {

  }

  // --------------------------- Input Search --------------------------- //

  search(event: any) {

  }

}
